import { Component, OnInit } from '@angular/core';
import { KuiModalRefComponent } from 'app/key-ui/modal/modal-ref.component';
import { IKuiModalAction } from 'app/key-ui';
import { TranslateService } from '@ngx-translate/core';

export interface JsonModalOptions {
    object: any;
    heading?: string;
}

@Component({
    templateUrl: 'json.component.html',
    styleUrls: ['json.component.scss'],
    standalone: false
})
export class JsonModalComponent extends KuiModalRefComponent<JsonModalOptions> implements OnInit {

    modalActions: IKuiModalAction[];

    constructor(
        private i18n: TranslateService
    ) {
        super();
    }

    ngOnInit() {

        this.modalActions = [{
            text: this.i18n.instant('DIALOG.CLOSE'),
            style: 'primary',
            keypress: 27,
            action: () => {
                this.actions.close(false);
            },
        }];

    }

    detachModal() {
        this.actions.close(false);
    }
}
